import { Stack, type StackProps } from "~/common/mui";

export const DesignationContainer = (props: StackProps) => {
  return <Stack gap={0} direction="row" alignItems="center" {...props} />;
};
